import "./App.scss";
import React, { useState } from "react";
import { kc, authEnabled, getUserRoleLabel } from "./keycloakConfig";
import ResetUserPassword from "./Usermodule/ResetUserPassword";

const images = require.context("./assets/images", true);

function Header() {
  const redirectUrl = process.env.REACT_APP_REDIRECT_URL;
  const redirect = process.env.REACT_APP_Redirection_URL;
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [userId, setUserId] = useState("");
  const userEmail = localStorage.getItem("userEmail") || "";

  const handleLogout = () => {
    // Clear local storage
    localStorage.clear();
    sessionStorage.clear();

    // Clear cookies
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    // Clear service worker cache
    if ("serviceWorker" in navigator) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    if (authEnabled && kc) {
      kc.logout({ redirectUri: redirect });
    } else {
      window.location.href = redirectUrl;
    }
  };

  const handlePasswordModal = (userId) => {
    setShowPasswordModal(!showPasswordModal);
    setUserId(userId);
  };

  const handleCloseModal = () => {
    setShowPasswordModal(false);
    setUserId("");
  };

  return (
    <div className="header-wrapper">
      <div className="d-flex align-items-center justify-content-between">
        <div className="header-logo">
          <img
            className="img-fluid"
            style={{ marginLeft: 10, marginTop: 5, marginBottom: 5 }}
            src={images(`./main-logo.svg`)}
            alt="Main-logo"
            height="100"
            width="200"
          />
        </div>
        <div className="user-account-wrapper">
          <div className="dropdown">
            <button
              className="btn profile_account_btn"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src={images(`./account-prof-pic.svg`)}
                alt="Profile-Pic"
                height="38"
                width="38"
              />
            </button>
            <ul
              className="dropdown-menu account_details"
              aria-labelledby="dropdownMenuButton1"
            >
              <div className="header_account_details text-center">
                <img
                  src={images(`./account-prof-pic.svg`)}
                  alt="Profile-Pic"
                  height="64"
                  width="64"
                />
                <p className="account-name">{userEmail}</p>
                <p className="account-type">{getUserRoleLabel()}</p>
              </div>
              <li>
                <a className="dropdown-item" href="/UpdateUserProfile/">
                  Profile View
                </a>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => handlePasswordModal("")}
                >
                  Change Password
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item text_red font_weight_medium"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {showPasswordModal && (
        <div className="modal" tabIndex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{color:"#4340d2"}}>Change Password</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <ResetUserPassword userId={userId} onClose={handleCloseModal} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;